import React, { Component } from 'react';
import ThemedButton from '../CommonComponents/ThemedButtons';
// @ts-ignore
import AddQueue from '../assets/icons/add.svg';
import { api } from '../utils';
// @ts-ignore
import CheckboxUnchecked from '../assets/icons/check_box_unchecked.svg';
// @ts-ignore
import checkedCheckBox from '../assets/icons/check_box_checked.svg';
import SearchBar from '../CommonComponents/SearchBar';
// @ts-ignore
import SearchIcon from '../assets/icons/search.svg';
// @ts-ignore
import crossImg from '../assets/icons/close-smallSize.svg';
// @ts-ignore
import RadioBtnUnchecked from '../assets/icons/radio_button_unchecked.svg';
// @ts-ignore
import RadioBtnchecked from '../assets/icons/radio_button_checked.svg';
// @ts-ignore
import InfoIcon from '../assets/icons/info.svg';

type Props = {
  addNewUser: Function;
  onClose: Function;
  src?: string;
  selectedBotId: string;
  origin?: string;
  userPreviousCheck?: Function;
  newArray?: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    currentQuest: any;
    RoleName: string;
    RoleId: number;
    firstName: string;
    lastName: string;
  }[];
};

type State = {
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  addQueues: boolean;
  queueList: {
    queueId: number;
    queueName: string;
    check: boolean;
  }[];
  searchTerm: string;
  selectedQueueList: {
    queueId: number;
    queueName: string;
    check: boolean;
  }[];
  adminRole: boolean;
  analystRole: boolean;
  roleType: string;
  agentRole: boolean;
  errorMessage: string;
};

export default class AddingNewUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.addQueueList = this.addQueueList.bind(this);
  }
  setInitialState(): State {
    return {
      userEmail: '',
      userFirstName: '',
      userLastName: '',
      addQueues: false,
      queueList: [],
      searchTerm: '',
      selectedQueueList: [],
      adminRole: false,
      analystRole: false,
      roleType: 'Agent',
      agentRole: false,
      errorMessage: '',
    };
  }

  addQueueList() {
    const list = this.state.queueList.filter((data) => data.check === true);
    this.setState({
      selectedQueueList: list,
    });
  }
  removeQueue(queueId: any) {
    this.setState((prevState) => ({
      selectedQueueList: prevState.queueList.map((obj) =>
        obj.queueId === queueId ? Object.assign(obj, { check: !obj.check }) : obj
      ),
    }));
  }
  get queueDetails() {
    const searchTerm = this.state.searchTerm.toLowerCase();
    return this.state.queueList.filter(
      (filterData) => filterData.queueName.toLowerCase().indexOf(searchTerm) >= 0
    );
  }

  render() {
    return (
      <div className='add-new-user' style={{ fontFamily: 'OpenSans' }}>
        <div style={{ lineHeight: 3.3, width: '390px' }}>
          {/* style={{ marginBottom: '20px' }} */}
          <div>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              autoComplete='off'
              onChange={(event) => {
                this.setState(
                  {
                    userEmail: event.target.value.split(' ').join(''),
                  },
                  () => {
                    this.props.userPreviousCheck &&
                      this.props.userPreviousCheck(this.state.userEmail);
                  }
                );
              }}
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.userEmail === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                Email
              </label>
            )}
            {this.props.newArray && this.props.newArray.length > 0 ? (
              <div
                id='mail-validation-error'
                style={{
                  fontSize: '10px',
                  letterSpacing: '-0.15px',
                  textAlign: 'right',
                  color: '#ff0000',
                  margin: ' -20px 15px -20px 0px',
                  fontFamily: 'OpenSans',
                }}>
                User already added
              </div>
            ) : null}
          </div>
          <div style={{ marginBottom: '20px' }}>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  userFirstName: event.target.value,
                });
              }}
              maxLength={140}
              autoComplete='off'
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.userFirstName === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                First Name
              </label>
            )}

            <div
              id='fname-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  userLastName: event.target.value,
                });
              }}
              maxLength={140}
              autoComplete='off'
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.userLastName === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                Last Name
              </label>
            )}
            <div
              id='lname-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div>
        </div>
        {this.props.src === 'team tab' && this.props.origin !== 'admin-analyst' && (
          <div className={this.state.selectedQueueList.length > 0 ? 'fit-data' : ''}>
            {this.state.addQueues && (
              <div className='add-team-queues-w'>
                <div className='add-team-queues'>
                  <SearchBar
                    placeholder='Search queues'
                    importedImg='yes'
                    icon={SearchIcon}
                    onSearch={(term: any) => {
                      this.setState({
                        searchTerm: term,
                      });
                    }}
                  />
                  <div style={{ maxHeight: '210px', overflowY: 'auto' }}>
                    {this.queueDetails.map((queueData, i) => {
                      return (
                        <div
                          key={i}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '7px',
                            overflowY: 'auto',
                          }}>
                          <img
                            src={queueData.check ? checkedCheckBox : CheckboxUnchecked}
                            onClick={() => {
                              this.setState((prevState) => ({
                                queueList: prevState.queueList.map((obj) =>
                                  obj.queueId === queueData.queueId
                                    ? Object.assign(obj, { check: !queueData.check })
                                    : obj
                                ),
                              }));
                            }}
                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            alt='queue-check'
                          />

                          <div style={{ marginLeft: '10px' }}>{queueData.queueName}</div>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      padding: '10px 0px 10px 0px',
                    }}>
                    <ThemedButton
                      theme='4'
                      title='Done'
                      onClick={() => {
                        this.addQueueList();
                        this.setState({
                          addQueues: !this.state.addQueues,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div style={{ lineHeight: 2 }}>Assigned Queues</div>
            <div
              className={`agent-pills ${
                this.state.selectedQueueList.length > 0 ? 'align-data' : ''
              } `}>
              {this.state.selectedQueueList &&
                this.state.selectedQueueList.map((list, i) => {
                  if (list.check === true) {
                    return (
                      <div key={i}>
                        <div style={{ fontSize: '14px' }}>{list.queueName}</div>
                        <img
                          src={crossImg}
                          alt='close'
                          onClick={() => {
                            this.removeQueue(list.queueId);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    );
                  }
                })}
            </div>
            <div
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => {
                this.setState({
                  addQueues: !this.state.addQueues,
                });
              }}>
              <img src={AddQueue} alt='add' style={{ marginLeft: '-5px' }} />
              <span style={{ color: '#6c7ef2', fontSize: '14px' }}>Add</span>
            </div>
          </div>
        )}
        {this.props.origin === 'admin-analyst' && (
          <>
            <div style={{ fontSize: '16px' }}>Select role</div>
            <div style={{ display: 'flex', marginTop: '15px' }}>
              <img
                src={
                  this.state.roleType === 'Admin' ? RadioBtnchecked : RadioBtnUnchecked
                }
                alt='radio-btn'
                onClick={() => {
                  this.setState({
                    adminRole: !this.state.adminRole,
                    analystRole: false,
                    roleType: 'Admin',
                  });
                }}
                style={{ width: '18px', height: '18px' }}
              />
              <div
                style={{ marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '14px' }}>Admin</span>
                <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                  Access only to bot configurations and analytics in Hybrid Chat{' '}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', marginTop: '15px' }}>
              <img
                src={
                  this.state.roleType === 'Analyst' ? RadioBtnchecked : RadioBtnUnchecked
                }
                alt='radio-btn'
                onClick={() => {
                  this.setState({
                    analystRole: !this.state.analystRole,
                    adminRole: false,
                    roleType: 'Analyst',
                  });
                }}
                style={{ width: '18px', height: '18px' }}
              />
              <div
                style={{ marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '14px' }}>Analyst</span>
                <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                  Access only to Hybrid Chat analytics{' '}
                </div>
              </div>
            </div>{' '}
            <div style={{ display: 'flex', marginTop: '15px' }}>
              <img
                src={
                  this.state.roleType === 'Agent' ? RadioBtnchecked : RadioBtnUnchecked
                }
                alt='radio-btn'
                onClick={() => {
                  this.setState({
                    agentRole: !this.state.agentRole,
                    analystRole: false,
                    roleType: 'Agent',
                  });
                }}
                style={{ width: '18px', height: '18px' }}
              />
              <div
                style={{ marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '14px' }}>Agent</span>
                <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                  Access only to chat screens & bot queues{' '}
                </div>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '10px 0px 10px 0px',
              }}>
              <img src={InfoIcon} alt='info' />
              <span
                style={{
                  color: 'rgba(0, 0, 0, 0.6)',
                  fontSize: '10px',
                  marginLeft: '10px',
                }}>
                Login credentials will be sent to the new user’s email
              </span>
            </div>
          </>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ marginRight: '10px' }}>
            <ThemedButton
              theme='3'
              title='Cancel'
              onClick={() => {
                this.props.onClose();
              }}
            />
          </div>
          <ThemedButton
            theme='4'
            title={this.props.src === 'team tab' ? 'Done' : 'Add'}
            onClick={() => {
              this.props.addNewUser(
                this.state.userEmail,
                this.state.userFirstName,
                this.state.userLastName,
                this.state.selectedQueueList,
                this.state.roleType
              );
            }}
            disabled={
              this.state.roleType !== '' &&
              this.state.userEmail !== '' &&
              this.state.userFirstName !== '' &&
              this.state.userLastName !== '' &&
              this.props.newArray &&
              this.props.newArray.length === 0
              // this.props.checkValid === false
            }
          />
        </div>
      </div>
    );
  }
}
